import * as auth from '../../app/modules/auth/redux/AuthRedux'

let isSessionExpiryLogoutInProgress = false

const getLoginRedirectUrl = () => {
  const publicUrl = (process.env.PUBLIC_URL ?? '').replace(/\/$/, '')
  return `${window.location.origin}${publicUrl}/auth/login`
}

export default function setupAxios(axios: any, store: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: {accessToken},
      } = store.getState()

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  axios.interceptors.response.use(
    (response: any) => response,
    (err: any) => {
      const status = err?.response?.status
      const accessToken = store.getState()?.auth?.accessToken

      if (status === 401 && accessToken && !isSessionExpiryLogoutInProgress) {
        isSessionExpiryLogoutInProgress = true
        store.dispatch(auth.actions.logout())
        window.location.replace(getLoginRedirectUrl())
      }

      return Promise.reject(err)
    }
  )
}
